<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainer/trainerDashboard?training='+this.AssigntrainingCode,
                    }
                    ,{
                      title: 'Feedback',
                      url: '/#/dashboard/Trainer/trainerFeedback',
                       active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">Feedback</h3>
            </div>

            <!-- <div class="form-group form-row text-dark">
          <div class="col-sm-8">
            <vs-input icon="search" placeholder="Search Training Name or Code" v-model="search" />
          </div>
            </div>-->

            <!-- <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Training Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-1 font-weight-bold">Title:</label>
                <div class="col-sm-11" v-if="trainingDetails !=''">{{trainingDetails.title}}</div>
              </div>
              <div
                class="row col-sm-12"
                v-for="(dates,dateIndex) in trainingDates"
                :key="dateIndex"
              >
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Start Date:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">{{dates.startDate}}</p>

                <label class="col-sm-2 font-weight-bold p-0">End Date:</label>
                <p class="col-sm-4 p-0">{{dates.endDate}}</p>
              </div>
            </div>-->
            <div class="questionScreen d-flex flex-column">
              <div class="d-flex p-2">
                <div class="training-code pr-2">
                  <h6 class="training-code-clr">T001</h6>
                </div>
                <div class="training-title">
                  <h6>{{trainingDetails.title}}</h6>
                  <small>{{trainingDetails.startdate}} - {{trainingDetails.enddate}}</small>
                  <p>{{trainingDetails.address}}</p>
                </div>
              </div>
              <div class="pl-2 mb-2">
               
              
              <template v-if="submittedStatus == 0">
                 <h5>Feedback</h5>
                <!-- <b>
                <span class="float-right">60%</span>
              </b>
                <vs-progress :height="4" :percent="60" color="success">success</vs-progress>-->

                <form @submit.prevent="trainerfeedback">
                  <!-- {{feedbackQuestions}} -->
                  <div class="form-group form-row mt-3">
                   
                    <p class="mr-2">
                      <i>Click on the right option below</i>
                    </p>
                    <div class="col-sm-12 col-md-12 col-lg-12" v-if="feedbackQuestions.length >0">
                      <input type="hidden" v-model="training_id" />

                      <h6
                        class="text-left text-dark"
                        v-if="feedbackQuestions[currentQ] != undefined && feedbackQuestions[currentQ].qtitle != undefined"
                      >{{currentQ+1}}){{feedbackQuestions[currentQ].qtitle}} {{feedbackQuestions[currentQ].question}}</h6>
                      <div class="float-right" style="margin-top:-25px">
                        <vs-chip color="primary" class="p-2">{{currentQ+1}}/{{feedbackQuestions.length}}</vs-chip>
                      </div>
                    </div>
                    <div v-else>
                      <h6 class="text-left text-dark"> No Feedback Found</h6>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12">
                      <ul
                        v-for="(options,index) in feedbackQuestionOptions"
                        :key="index"
                        class="align-items-start"
                      >
                        <li
                          v-if="options.oquestionBank_id == feedbackQuestions[currentQ].qid && feedbackQuestions[currentQ].questionType =='mcqs' "
                        >
                          <vs-radio
                            v-model="selectedOptions[currentQ].answer"
                            :vs-value="options.oid"
                          >{{options.otitle}}</vs-radio>
                        </li>
                        <li
                          v-else-if="options.oquestionBank_id == feedbackQuestions[currentQ].qid && feedbackQuestions[currentQ].questionType =='descriptive' "
                        >
                          <vs-textarea v-model="selectedOptions[currentQ].answer" />
                          <!-- <vs-radio v-model="selectedOptions[currentQ].answer"  :vs-value="options.oid">{{options.otitle}}</vs-radio> -->
                        </li>
                      </ul>
                    </div>
                  </div>
                  <template v-if="selectedOptions !=''">
                    <b-button
                      type="submit"
                      class="save-btn float-left"
                      variant="primary"
                      v-if="currentQ+1 == feedbackQuestions.length & selectedOptions[feedbackQuestions.length - 1].answer !='' "
                    >Submit</b-button>

                    <div v-else>
                      <b-button
                        v-if="selectedOptions[currentQ].answer !=''"
                        class="save-btn float-left"
                        variant="primary"
                        @click="next()"
                      >Next</b-button>
                    </div>
                  </template>
                </form>
              </template>
              <template v-else>
                <div class="feedback_submitted">
                  <h6>You have submitted Feedback</h6>
                </div>
              </template>
              </div>
            </div>
            <!-- <b-button   @click="isShowing =  !isShowing" class="save-btn float-left" variant="primary" >back</b-button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "axios";

export default {
  data: () => ({
    isSidebar: false,
    indexActive: 0,
    training_id: "",
    submittedStatus: "",
    feedbackQuestions: [],
    feedbackQuestionOptions: [],
    selectedOptions: [],
    trainingDetails: [],
    trainingDates: [],
    optionsCounter: 1,
    textarea: "",
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    currentQ: 0
  }),
  mounted() {},
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  created() {
    this.AssigntrainingCode = this.$route.query.training;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/get/trainer/traning_id/" +
          this.AssigntrainingCode
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data.trainingDetails) {
          this.trainingDetails = response.data.trainingDetails;
          this.training_id = response.data.trainingDetails.id;
          this.checkTrainerFeedback(this.training_id);
        }
      });
  },
  methods: {
    // Set the initial number of items
    // this.totalRows = this.items.length;
    checkTrainerFeedback: function checkTrainerFeedback(trngId) {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/check/trainer/feedback/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/" +
            trngId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.count == 1) {
            this.submittedStatus = response.data.count;
          } else {
            this.submittedStatus = response.data.count;
            this.allQuestions(trngId);
          }
        });
    },

    allQuestions: function allQuestions(trainingId) {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainer/training/feedback/get/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/" +
            trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.feedbackQuestions = response.data["questionArray"];

          for (var i = 0; i < this.feedbackQuestions.length; i++) {
            this.selectedOptions.push({
              lengthh: i,
              type: this.feedbackQuestions[i].questionType,
              answer: "",
              assesmentID: this.feedbackQuestions[i].assesmentID
            });
          }
          if (
            response.data.optionArray != undefined &&
            response.data.optionArray != ""
          ) {
            this.feedbackQuestionOptions = response.data["optionArray"][0];
          }
        });
    },
    trainerfeedback(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      this.selectedOptions.forEach(element => {
        if (element.answer == "") {
          this.inValid.push("Please select an option.");
        }
      });
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/trainer/feedback/save", {
            feedback: this.selectedOptions,
            trainer_id: JSON.parse(localStorage.getItem("currentUser")).id + "",
            training_id: this.training_id
          },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
         
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              this.submittedStatus = 1;
              self.$toasted.global.successMsg("Feedback Submitted Successfully!");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    next: function() {
      if (this.currentQ + 1 < this.feedbackQuestions.length) {
        this.currentQ++;
      }
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    isShowing: function() {
      if (this.currentQ - 1 < this.questions.length) {
        this.currentQ--;
      }
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
li {
  list-style-type: none !important;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.questionScreen {
  border: 1px solid #fff0a2;
  background-color: #fffae5;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
textarea.vs-textarea {
  width: 100% !important;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.con-vs-radio {
  justify-content: left !important;
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
  width: 100%;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}
.feedback_submitted {
  text-align: center;
}
.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

/* Uploading file css */
/* .con-img-upload .img-upload{
  height:25px !important;
}
.con-input-upload{
  height:25px !important;
}
h4.text-archive{
  font-size: 13px !important
}
.con-img-upload .img-upload .btn-x-file i{
  font-size:10px !important;
}
.con-img-upload .img-upload .btn-upload-file:not(.on-progress):hover i{

    font-size: 12px !important;
    background: rgba(var(--vs-success),1);
    top: 15% !important;
    padding: 10px;
}

.vs-upload--button-upload:hover {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
    background: rgba(var(--vs-primary),1);
    color: #fff;
} */
.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
</style>


